import { useState } from 'react'
import { AggregateRoot } from './useMasterScheduleParameter'

export type ResourceDashboardParameter = {
  root: AggregateRoot | undefined
  setRoot: (_: AggregateRoot | undefined) => void
}
export const useResourceDashboardParameter = (): ResourceDashboardParameter => {
  const [root, setRoot] = useState<AggregateRoot>()

  return {
    root,
    setRoot,
  }
}
